import { type ReactNode } from 'react';
import { Heading } from '@hungryroot/ramen';

import styles from './ContinueWithOr.module.css';

type Props = {
  children: ReactNode;
};

export function ContinueWithOr({ children }: Props) {
  return (
    <>
      <Heading className={styles.continue} variant="H6">
        Continue with
      </Heading>
      <section className={styles.sso}>{children}</section>
      <div className={styles.or}>or</div>
    </>
  );
}
